export enum APITagType {
  SurveyList = 'survey-list',
  AdminSurvey = 'admin-survey',
  BrandOffer = 'brand-offer',
  Company = 'company',
  InsertionOrder = 'insertion-order',
  InvoiceGroup = 'invoice-group',
  MagazineTitle = 'magazine-title',
  PacingView = 'pacing-view',
  SuspensionReason = 'suspension-reason',
  YodleeBankAccount = 'yodlee-bank-account',
  YodleeToken = 'yodlee-link-token',
  Summaries = 'summaries',
  MediaPlan = 'media-plan',
  PulsePollingConfig = 'pulse-polling-config',
  OrganizationClients = 'organization-clients',
  Panel = 'panel',
  CommissionPnl = 'commission-pnl',
  CommissionReferrals = 'commission-referrals',
  CommissionReports = 'commission-reports',
  CommissionUsers = 'commission-users',
  TrendsEvents = 'trends-events',
  SurveyGroups = 'survey-groups',
}

export type TagProviderResult = {
  readonly id: string;
  readonly type: APITagType;
};

export type TagInvalidator = APITagType | { id: string, type: APITagType };
